import React from 'react';
import App from './component';

const AppSceneWrapper = props => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <App {...props} />
);

export default AppSceneWrapper;
